export default "__VITE_ASSET__MjKo0Odg__"